import React from 'react'

import { FormikProps } from 'formik'

import { FormFieldName } from './AddSupplier.form'
import { Email } from './Email'
import { PrimaryContact } from './PrimaryContact'
import { SupplierInformation } from './SupplierInformation'
import { Title } from './Title'

type Props = {
  formik: FormikProps<any>
  isFormFieldInvalid: (name: FormFieldName) => boolean
  getFormErrorMessage: (name: FormFieldName) => JSX.Element
  wrongSupportEmails: string[] | null
  wrongInboundEmails: string[] | null
  wrongOutboundEmails: string[] | null
  separator: string
  isRequestRunning: boolean
}

export const AddSupplierView: React.FC<Props> = ({
  formik,
  isFormFieldInvalid,
  getFormErrorMessage,
  wrongSupportEmails,
  wrongInboundEmails,
  wrongOutboundEmails,
  separator,
  isRequestRunning,
}) => {
  return (
    <>
      <Title
        isLoading={false}
        formik={formik}
        isRequestRunning={isRequestRunning}
      />

      <SupplierInformation
        formik={formik}
        isFormFieldInvalid={isFormFieldInvalid}
        getFormErrorMessage={getFormErrorMessage}
        isRequestRunning={isRequestRunning}
      />

      <PrimaryContact
        formik={formik}
        separator={separator}
        isFormFieldInvalid={isFormFieldInvalid}
        wrongSupportEmails={wrongSupportEmails}
        getFormErrorMessage={getFormErrorMessage}
        isRequestRunning={isRequestRunning}
      />

      <Email
        formik={formik}
        separator={separator}
        isFormFieldInvalid={isFormFieldInvalid}
        wrongInboundEmails={wrongInboundEmails}
        wrongOutboundEmails={wrongOutboundEmails}
        getFormErrorMessage={getFormErrorMessage}
        isRequestRunning={isRequestRunning}
      />
    </>
  )
}
